/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'agent/discovered': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<g _fill="none" _stroke="#000" stroke-miterlimit="10"><path pid="0" stroke-width="2" d="M20 55s-4-21-2-23 10-1 10.5-5v-2c0-.697-.574-3.172-1-4-.425-.828-1-3.663-1-5 0-1.338-.098-2.776.5-3.973C28.514 9 30.486 9 32 9c1.514 0 3.486 0 5 3.027.598 1.197.5 2.635.5 3.973 0 1.337-.764 4.551-1 5-.236.45-1 3.331-1 4v2c.5 4 8.5 3 10.5 5s-2 23-2 23"/><path pid="1" stroke-linecap="round" d="M36 38l-8 8M28 38l8 8"/></g>'
  }
})
